// src/components/AppointmentList.js
import { useState, useEffect } from 'react';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Typography
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import RatingForm from './RatingForm.js';
import axios from 'axios';

function AppointmentList(props) {
    const [appointments, setAppointments] = useState([]);
    const [error, setError] = useState(null);
    const location = useLocation();
    const user = location.state?.user || '';
    const [isPastMode, setIsPastMode] = useState(false);
    const [openRatingId, setOpenRatingId] = useState(null);
    const [submittedFeedbackIds, setSubmittedFeedbackIds] = useState([]);
    const [isCanceling, setIsCanceling] = useState(null);
    const { visible, setVisible } = props;

    useEffect(() => {
        const pastParam = new URLSearchParams(location.search).get('past');
        const newIsPastMode = pastParam?.toLowerCase() === 'true';
        setIsPastMode(newIsPastMode);
    }, [location.search]);

    const fetchAppointments = async () => {
        try {
            const apptsUrl = (process.env.REACT_APP_SERVER)
                ? `https://salonserver-k8m8.onrender.com/appointments`
                : `http://localhost:3001/appointments`;

            const response = await axios.get(apptsUrl, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": ` ${localStorage.getItem("token")} `,
                },
                params: { past: isPastMode },
            });

            setAppointments(response.data);
            console.log('appointments', response.data);
        } catch (error) {
            console.error('Error fetching appointments', error);
        }
    };
    useEffect(() => {
        setVisible(false);


        if (user) {
            fetchAppointments();
        }
    }, [user, isPastMode]);

    async function handleStatusUpdate(id, status) {
        const apptsUrl = (process.env.REACT_APP_SERVER)
            ? `https://salonserver-k8m8.onrender.com/appointments`
            : `http://localhost:3001/appointments`;

        if (window.confirm('Are you sure you want to cancel this appointment?')) {
            console.log('auth token', localStorage.getItem('token'));
            try {
                const response = await axios.patch(
                    `${apptsUrl}/${id}`,
                    { status: 'canceled' },
                    { headers: { Authorization: ` ${localStorage.getItem('token')}` } }
                );
                console.log('response', response);
                setAppointments(appointments.filter((appt) => appt.id !== id));
                alert('Appointment canceled successfully');

            } catch (err) {
                setError('Failed to update appointment status');
            }
        }
    }

    if (!user) {
        return <p>Please log in to view appointments.</p>;
    }
    // Inside your component, before return
    const sortedAppointments = [...appointments].sort((a, b) => new Date(b.apptdate) - new Date(a.apptdate));

    return (
        // <div style={{ minHeight: '80vh' }}></div>
        <div style={{ padding: 16, minHeight: '65vh' }}>
            <Typography variant="h6" gutterBottom>
                {isPastMode ? 'Past Bookings' : 'Upcoming Bookings'}
            </Typography>

            {error && <Typography color="error">{error}</Typography>}

            {appointments.length === 0 ? (
                <Typography variant="body2">
                    No {isPastMode ? 'past' : 'upcoming'} appointments found.
                </Typography>
            ) : (
                <TableContainer component={Paper} elevation={2}>
                    <Table size="small">
                        <TableHead >
                            <TableRow key={Date.now()} sx={{ backgroundColor: '#f5f5f5' }} >
                                <TableCell><strong>Salon</strong></TableCell>
                                <TableCell><strong>Mobile</strong></TableCell>
                                <TableCell><strong>Date</strong></TableCell>
                                <TableCell><strong>Time</strong></TableCell>
                                <TableCell><strong>Service</strong></TableCell>
                                <TableCell><strong>Status</strong></TableCell>
                                <TableCell><strong>Actions</strong></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {sortedAppointments.map((appt) => (
                                <TableRow key={appt.id}>
                                    <TableCell sx={{ py: 0.5 }}>{appt.salon.name}</TableCell>
                                    <TableCell sx={{ py: 0.5 }}>{appt.salon.mobile}</TableCell>
                                    <TableCell sx={{ py: 0.5 }}>{new Date(appt.apptdate).toLocaleDateString()}</TableCell>
                                    <TableCell sx={{ py: 0.5 }}>{new Date(appt.appttime).toLocaleTimeString()}</TableCell>
                                    <TableCell sx={{ py: 0.5 }}>{appt.service}</TableCell>
                                    <TableCell sx={{ py: 0.5 }}>
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color:
                                                    appt.status === 'confirmed'
                                                        ? 'green'
                                                        : appt.status === 'canceled'
                                                            ? 'red'
                                                            : 'orange',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {appt.status}
                                        </Typography>
                                    </TableCell>
                                    <TableCell sx={{ py: 0.5 }}>
                                        {/* {console.log('ids', submittedFeedbackIds)} */}
                                        {appt.status !== 'canceled' && (
                                            <div style={{ display: 'flex', gap: 6 }}>
                                                {isPastMode ? (
                                                    // !submittedFeedbackIds.includes(appt.id) && (
                                                    appt.rating == null && (
                                                        <Button
                                                            variant="outlined"
                                                            size="small"
                                                            color="primary"
                                                            onClick={() => setOpenRatingId(appt.id)}
                                                        >
                                                            Feedback
                                                        </Button>
                                                    )
                                                ) : (
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        color="error"
                                                        onClick={() => handleStatusUpdate(appt.id, 'canceled')}
                                                        disabled={appt.status === 'canceled' || isCanceling === appt.id}
                                                    >
                                                        Cancel
                                                    </Button>
                                                )}
                                            </div>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            {openRatingId && (
                <Dialog open onClose={() => setOpenRatingId(null)}>
                    <DialogTitle>Rate Appointment</DialogTitle>
                    <DialogContent>
                        <RatingForm
                            appointmentId={openRatingId}
                            onClose={() => setOpenRatingId(null)}
                            onSubmitSuccess={async (id) => {
                                // setSubmittedFeedbackIds((prev) => [...prev, id]);
                                setOpenRatingId(null);
                                await fetchAppointments();  // 🔥 Refresh data
                            }}
                        />
                    </DialogContent>
                </Dialog>
            )}
        </div>
    );
}

export default AppointmentList;



